import { ISection } from '@features/productPreview/typescript';
import { TIcon } from '@components/icons/typescript';
export type DescriptionCodeType = 'PRODUCT_DESCRIPTIONS' | 'PRODUCT_ATTRIBUTES' | 'PRODUCT_TECHNICAL' | 'PRODUCT_FINISH' | 'PRODUCT_VIDEO' | 'PRODUCT_DELIVERY_ASSEMBLY' | 'PRODUCT_COLOR' | 'PRODUCT_DIMENSIONS' | 'PRODUCT_PROPERTIES' | 'PRODUCT_MANUFACTURER' | 'PRODUCT_ENERGY_CLASS' | 'PRODUCT_INSTRUCTIONS_CERTIFICATES' | 'PRODUCT_INFORMATION_PAGE_URL' | 'PRODUCT_INFORMATION_SHEET' | 'PRODUCT_INFORMATION_LABEL_URL' | 'DEFAULT';
export enum PhotoSizeType {
  THUMBNAIL = 'THUMBNAIL',
  MEDIUM = 'MEDIUM',
  NORMAL = 'NORMAL',
  FULL = 'FULL',
}
export type TVideo = 'VIDEO_FILE' | 'youtube';
export type TEnergyClass = 'ENERGY_CLASS_FILE';
export type TProductDocument = 'PRODUCT_DOCUMENT';
export type ContentIconType = {
  id: number;
  icon: TIcon;
  description: string;
};
export type ContentPictureType = {
  id: number;
  image: string;
  description: string;
};
export type ContentTechnicalPhotoItemType = {
  id: number;
  sizes: {
    MEDIUM: string;
    NORMAL: string;
    FULL: string;
  };
  url: string;
  role: 'PRODUCT_TECHNICAL';
};
export type ContentVideoItemType = {
  thumb: string;
  video: string;
  type: TVideo | TEnergyClass | TProductDocument;
  url?: string;
  name?: string;
};
export type PlainHtmlType = string; // unknown type

export type ContentDeliveryAssemblyType = {
  title: string;
  item: PlainHtmlType;
};
export type ContentTechnicalType = {
  dimension: string;
  value: string;
  unit: string;
  fromLabel: 'true' | 'false';
};
export type ProductContentType = ContentIconType[] | ContentPictureType[] | ContentTechnicalPhotoItemType[] | ContentVideoItemType[] | ContentDeliveryAssemblyType[] | PlainHtmlType;
export interface ISectionParameter {
  code: string;
  name: string;
  icon: string;
}
export interface ISectionDescriptionItem {
  code: string;
  descriptionCode: DescriptionCodeType;
  title: string;
  content: ProductContentType;
  technicalPictureItems: ContentTechnicalPhotoItemType[];
  parameters?: ISectionParameter[];
  video?: ContentVideoItemType;
  files?: ContentVideoItemType[];
}
export interface IAttributesSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_ATTRIBUTES';
  content: ContentIconType[];
}
export interface IFinishSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_FINISH';
  content: Array<ContentPictureType>;
}
export interface IVideoSection extends ISectionDescriptionItem {
  type: 'PRODUCT_VIDEO';
  files: ContentVideoItemType[];
}
export interface ITechnicalSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_TECHNICAL';
  content: PlainHtmlType;
}
export interface IDimensionsSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_DIMENSIONS';
  content: PlainHtmlType;
}
export interface IPropertiesSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_PROPERTIES';
  properties: ISectionParameter[];
}
export interface IManufacturerGprsSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_MANUFACTURER';
  properties: ISectionParameter[];
}
export interface IEnergyClassSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_ENERGY_CLASS';
  content: PlainHtmlType;
}
export interface IInformationPageUrlSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_INFORMATION_PAGE_URL';
}
export interface IInformationSheetSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_INFORMATION_SHEET';
}
export interface IInformationLabelUrlSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_INFORMATION_LABEL_URL';
}
export interface IInstructionsCertificatesSection extends ISectionDescriptionItem {
  descriptionCode: 'PRODUCT_INSTRUCTIONS_CERTIFICATES';
  content: PlainHtmlType;
}
export interface IDeliveryAssemblySection extends ISectionDescriptionItem {
  type: 'PRODUCT_DELIVERY_ASSEMBLY';
  content: ContentDeliveryAssemblyType[];
  video: ContentVideoItemType;
}
export interface IDescriptionSection extends ISection {
  type: 'PRODUCT_DESCRIPTIONS';
  items: ISectionDescriptionItem[];
}
export interface IVideoProductSection extends ISection {
  type: 'VIDEO_PRODUCT';
  items: ISectionDescriptionItem[];
}
export type TConfiguratorsTypes = 'front' | 'basic' | 'old';